import * as types from "./actionType";

export const FranchiseLicense_Get_Action = () => ({
    type: types.FRANCHISE_LICENSE_GET,
});

export const FranchiseLicense_Get_Success = (payload) => ({
    type: types.FRANCHISE_LICENSE_GET_SUCCESS,
    payload,
});

export const FranchiseLicense_Post_Action = ({ jsonBody }) => ({
    type: types.FRANCHISE_LICENSE_POST,
    payload: { jsonBody },
});

export const FranchiseLicense_Post_Success = (payload) => ({
    type: types.FRANCHISE_LICENSE_POST_SUCCESS,
    payload,
});

export const FranchiseLicense_Api_Error = (error) => ({
    type: types.FRANCHISE_LICENSE_API_ERROR,
    payload: error,
});